import { StaticRoutes } from './model/routes';
import * as roles from 'core/model/roles';

const menu = [
	{
		name: 'settings',
		role: roles.ADMIN,
		children: [
			{
				name: 'content',
				icon: 'fa fa-sitemap',
				url: StaticRoutes.ContentEdit,
				domain: 'admin',
			},
		],
		domain: 'admin',
	},
];

export default menu;
